import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontIcon } from "component/w24/component/FontIcon"
import { motion } from "framer-motion"
import { AnimTap, EColors, EFonts, EVariables } from "libs/style/w24_styling"
import React from "react"
import styled, { css } from "styled-components/macro"

interface Props {
  title: string
  icon: IconDefinition
  onClick?: () => void
  disabled?: boolean
  className?: string
}

export const CoreButton = (props: Props): JSX.Element => {
  const anim = !props.disabled ? { ...AnimTap } : {}

  return (
    <S_CoreButton
      className={props.className}
      {...anim}
      onClick={() => {
        if (props.onClick && !props.disabled) props.onClick()
      }}
      disabled={props.disabled}
      $disabled={props.disabled}
    >
      <S_Title>{props.title}</S_Title>
      <S_Circle $disabled={props.disabled}>
        <FontIcon icon={props.icon} color={EColors.WHITE} iconSize="18px" />
      </S_Circle>
    </S_CoreButton>
  )
}

const S_CoreButton = styled(motion.button)<{ $disabled: boolean }>`
  display: inline-flex;
  padding: 3px 3px 3px 19px;
  align-items: center;
  gap: 15px;
  background-color: ${EColors.WHITE};
  width: fit-content;
  cursor: pointer;
  border-radius: ${EVariables.Radius1};
  outline: none;
  border: none;
  ${props => {
    if (props.$disabled)
      return css`
        background-color: ${EColors.GREY1};
        cursor: not-allowed;
      `
  }}
  @media only screen and (min-width: 1260px) {
    padding: 11px 12px 11px 22px;
  }
`
const S_Title = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Medium};
  font-size: 15px;
  margin: 2px 0 0 0;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
    font-family: ${EFonts.Bold};
  }
`

const S_Circle = styled.div<{ $disabled: boolean }>`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${EColors.DARK};
  border-radius: 50%;
  ${props => {
    if (props.$disabled)
      return css`
        background-color: #a0a0a0;
      `
  }}
`
